function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["children", "apiKey"],
  _excluded2 = ["onSearchState"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { connectStateResults } from 'react-instantsearch-dom';
import serverDispatch from '../services/serverDispatch';
var AlgoliaSearchStateContext = /*#__PURE__*/React.createContext();
var Provider = AlgoliaSearchStateContext.Provider;
var deferSideEffect = function deferSideEffect(callback) {
  if (typeof window !== 'undefined') {
    window.setTimeout(callback, 0);
  }
};
function parseQuery(queryString) {
  var query = {};
  var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}
var AlgoliaSearchStateProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    apiKey = _ref.apiKey,
    props = _objectWithoutProperties(_ref, _excluded);
  var searchingRef = React.useRef(false);
  var handleSearchState = React.useCallback(function (searchState) {
    var wasSearching = searchingRef.current;
    searchingRef.current = searchState.searching;
    if (wasSearching && searchState.searching === false) {
      deferSideEffect(function () {
        var _searchState$error, _searchState$error2;
        if (searchState.allSearchResults) {
          serverDispatch({
            action: 'LOG_ALGOLIA_SEARCH',
            payload: {
              apiKey: apiKey,
              facetFilters: parseQuery(searchState.allSearchResults.params).facetFilters || null,
              index: searchState.allSearchResults.index,
              numericFilters: parseQuery(searchState.allSearchResults.params).numericFilters || null,
              page: searchState.allSearchResults.page
            }
          })["catch"](function (e) {
            return console.log(e);
          });
        }
        if (searchState !== null && searchState !== void 0 && (_searchState$error = searchState.error) !== null && _searchState$error !== void 0 && _searchState$error.message) alert(searchState === null || searchState === void 0 ? void 0 : (_searchState$error2 = searchState.error) === null || _searchState$error2 === void 0 ? void 0 : _searchState$error2.message);
      });
    }
    return /*#__PURE__*/React.createElement(Provider, {
      value: _objectSpread(_objectSpread({}, searchState), props),
      children: children
    });
  }, [apiKey, children, props]);
  return /*#__PURE__*/React.createElement(ConnectedSearchState, {
    onSearchState: handleSearchState
  });
});
var ConnectedSearchState = connectStateResults(function (_ref2) {
  var onSearchState = _ref2.onSearchState,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return onSearchState(props);
});
AlgoliaSearchStateProvider.propTypes = {};
AlgoliaSearchStateProvider.displayName = 'AlgoliaSearchStateProvider';
export default AlgoliaSearchStateProvider;
export { AlgoliaSearchStateContext };